:host {
  display: block;
  font-size: var(--sc-font-size-medium);
}


.close__button {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 22px;
}
